
export const apartments = [
  {
    id: 1,
    name: 'Apartamento 1',
    type: 'T0',
    capacity: 2,
    beds: 1,
    view: 'Vista Mar',
    price: 65,
    image: 'https://public.readdy.ai/ai/img_res/9983830605ab540c8e8742394751f8d3.jpg',
    featured: false,
    amenities: [
      { name: 'WiFi', icon: 'ri-wifi-line' },
      { name: 'Cozinha', icon: 'ri-restaurant-line' },
      { name: 'Self Check-in', icon: 'ri-key-line' },
      { name: 'Estacionamento', icon: 'ri-car-line' },
    ],
  },
  {
    id: 2,
    name: 'Apartamento 2',
    type: 'T0',
    capacity: 2,
    beds: 1,
    view: 'Vista Montanha',
    price: 60,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20studio%20apartment%20with%20mountain%20view%20in%20Madeira%2C%20natural%20light%2C%20white%20walls%2C%20wooden%20floors%2C%20comfortable%20double%20bed%20with%20neutral%20bedding%2C%20compact%20kitchenette%2C%20green%20mountains%20visible%20through%20window%2C%20minimalist%20modern%20interior%2C%20vacation%20rental%20photography&width=800&height=600&seq=apt2&orientation=landscape',
    featured: false,
    amenities: [
      { name: 'WiFi', icon: 'ri-wifi-line' },
      { name: 'Cozinha', icon: 'ri-restaurant-line' },
      { name: 'Self Check-in', icon: 'ri-key-line' },
      { name: 'Ar Condicionado', icon: 'ri-temp-cold-line' },
    ],
  },
  {
    id: 3,
    name: 'Apartamento 3',
    type: 'T0',
    capacity: 2,
    beds: 1,
    view: 'Vista Jardim',
    price: 58,
    image: 'https://readdy.ai/api/search-image?query=Bright%20studio%20apartment%20with%20garden%20view%20in%20Madeira%2C%20natural%20daylight%2C%20white%20walls%2C%20wooden%20floors%2C%20double%20bed%20with%20white%20linens%2C%20modern%20kitchenette%2C%20lush%20green%20garden%20visible%20through%20window%2C%20contemporary%20minimalist%20design%2C%20vacation%20rental%20interior&width=800&height=600&seq=apt3&orientation=landscape',
    featured: false,
    amenities: [
      { name: 'WiFi', icon: 'ri-wifi-line' },
      { name: 'Cozinha', icon: 'ri-restaurant-line' },
      { name: 'Self Check-in', icon: 'ri-key-line' },
      { name: 'Terraço', icon: 'ri-plant-line' },
    ],
  },
  {
    id: 4,
    name: 'Apartamento 4',
    type: 'T2',
    capacity: 4,
    beds: 2,
    view: 'Vista Mar Panorâmica',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20two%20bedroom%20apartment%20with%20panoramic%20ocean%20view%20in%20Madeira%2C%20spacious%20living%20room%20with%20large%20windows%2C%20modern%20furniture%2C%20white%20walls%2C%20wooden%20floors%2C%20blue%20Atlantic%20ocean%20view%2C%20premium%20vacation%20rental%20interior%2C%20bright%20natural%20light%2C%20contemporary%20elegant%20design&width=800&height=600&seq=apt4&orientation=landscape',
    featured: true,
    amenities: [
      { name: 'WiFi', icon: 'ri-wifi-line' },
      { name: 'Cozinha', icon: 'ri-restaurant-line' },
      { name: 'Self Check-in', icon: 'ri-key-line' },
      { name: 'Estacionamento', icon: 'ri-car-line' },
    ],
  },
];
